import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import "../../../src/App.css";

export interface ExDatepickerProps {
  name: string;
  title: string;
  error?: string;
  borderWidth?: string;
  borderColor?: string;
  [key: string]: any; // Allow additional props
  selectedDate?: Date;
  onChange?: (date: Date | null) => void;
  dateFormat?: string;
}

const ExDatepickerMonth = ({
  name,
  title,
  error,
  borderWidth = "border",
  selectedDate = new Date(),
  borderColor = "border-exgray-200",
  onChange,
  dateFormat = "MMMM YYYY",
  ...props
}: ExDatepickerProps) => {
  return (
    <div className="space-y-1">
      <label>{title}</label>
      <div className="w-full">
        <DatePicker
          selected={selectedDate}
          className="h-10 border border-exgray-300/80 outline-none rounded-lg px-2  focus:ring-0"
          //selected={selectedDate}
          onChange={onChange}
          dateFormat={dateFormat}
          //excludeDates={[new Date("2024-05-01"), new Date("2024-06-01")]}
          showMonthYearPicker
          maxDate={new Date()}
        />
      </div>
      <p className="text-red-400">{error}</p>
    </div>
  );
};

export default ExDatepickerMonth;
